import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import Navbar from "../component/Navbar";

import BackgroundImage from "../assets/images/property/pmgluxury/Hernando_Beach_Wtaerfront_Rentals.jpg";

import Property from "../component/Properties/property";
import Cta from "../component/cta";
import Footer from "../component/Footer";
import Switcher from "../component/Switcher";

export default function IndexEight() {
  const [bgLoaded, setBgLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = BackgroundImage;
    img.onload = () => setBgLoaded(true);
  }, []);

  return (
    <>
      <Navbar />
      <section
        className="relative overflow-hidden md:h-[90vh] h-[80vh] flex items-center bg-slate-900 bg-no-repeat bg-center bg-cover"
        style={{
          backgroundImage: bgLoaded ? `url(${BackgroundImage})` : 'none',
          transition: 'background-image 0.4s ease',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/60 via-slate-900/40 to-slate-900/85"></div>

        <div className="container relative z-10">
          <div className="text-center max-w-3xl mx-auto px-4">
            <p className="font-display italic text-gold-400 tracking-[0.3em] uppercase text-xs md:text-sm mb-6">
              — Florida Waterfront Living —
            </p>

            <h1 className="font-display text-white text-5xl md:text-7xl leading-tight mb-8">
              PMG Luxury Rentals
            </h1>

            <div className="flex items-center justify-center gap-4 mb-8">
              <span className="h-px w-12 bg-gold-500/70"></span>
              <p className="font-display italic text-gold-200 text-lg md:text-xl tracking-wide">
                Premium Luxury Home & Liveaboard Boat Slip Rentals
              </p>
              <span className="h-px w-12 bg-gold-500/70"></span>
            </div>

            <div className="mt-10">
              <Link
                to="/list"
                className="group inline-flex items-center gap-3 px-10 py-4 border border-gold-400 text-gold-100 hover:bg-gold-500 hover:text-slate-900 hover:border-gold-500 font-display tracking-[0.2em] uppercase text-sm transition-all duration-500"
              >
                View Our Properties
                <FiArrowRight className="text-base group-hover:translate-x-1 transition-transform duration-500" aria-hidden="true" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section id="main-content" className="relative md:py-5 py-16">
        <Property />
      </section>

      <Cta />

      <Footer />
      <Switcher />
    </>
  );
}
